export const trackPageView = () => {
  if (window.fbq) {
    window.fbq("track", "PageView");
  }
};

export const trackCustomEvent = (eventName, eventData = {}) => {
  if (window.fbq) {
    window.fbq("track", eventName, eventData);
  }
};